import { gql } from 'graphql-request'

export function categoryStoriesQuery(args: { categoryId: string, numStoriesLoaded: number }) {
  const { numStoriesLoaded, categoryId } = args
  return gql`
    query {
      categoryStories(first: ${numStoriesLoaded}, categoryId: "${categoryId}") {
        id
        title
        slug
        publicationDate
        author {
          id
          fullName
          slug
        }
        authorMultiple {
          id
          fullName
          slug
        }
        summary
        featuredImage {
          id
          url
        }
      }
    }
  `;
}

export function categoriesQuery() {
  return gql`
    query {
      categories {
        id
        name
        numStories
        slug
      }
    }
  `
}